export const HIGHSCORE_ADD_REQUEST = 'HIGHSCORE_ADD_REQUEST'
export const HIGHSCORE_ADD_SUCCESS = 'HIGHSCORE_ADD_SUCCESS'
export const HIGHSCORE_ADD_FAILURE = 'HIGHSCORE_ADD_FAILURE'


// WEBPACK FOOTER //
// ./src/modules/actionTypes.js